/** Release note item type */
export enum ReleaseNoteItemTypeEnum {
  NEW = 'new',
  IMPROVED = 'improved',
  FIXED = 'fixed',
  REMOVED = 'removed',
  INCIDENT = 'incident',
}

export type ReleaseNoteItemType = 'new' | 'improved' | 'fixed' | 'removed' | 'incident';

/** Release note item */
export interface ReleaseNoteItem {
  itemId: number;
  type: ReleaseNoteItemType;
  title: string;
  content: string;
  displayOrder: number;
}

/** Release note for viewing */
export interface ReleaseNoteView {
  releaseNoteId: number;
  releaseName: string;
  version?: string;
  description: string;
  releaseDate: Date;
  items?: ReleaseNoteItem[];
}

/** Filter option for release notes */
export interface FilterOption {
  value: 'all' | ReleaseNoteItemType;
  label: string;
  icon?: string;
}
